/**
 * What a picked address search suggestion (AddressInput, /api/globe/
 * address-autocomplete/) is saved as on a CRM partner. One rule for every
 * screen that saves a partner address.
 */
export default function addressFromSuggestion(suggestion) {
  return {
    formatted_address: suggestion.label,
    geometry: suggestion.geometry,
    place_name: suggestion.label,
    center: suggestion.center,
  };
}
